import React, { useState, useEffect } from "react"

import styles from "./locationPrice.module.scss"

import {
    getCountryByAbbreviation,
    getCountry,
    formatLocaleCurrency,
} from "country-currency-map"

import loading from "../../../images/loading.gif"

function LocationPrice({ product, currency }) {

    const [locationPrice, setLocationPrice] = useState(null)
    const [locationComparePrice, setLocationComparePrice] = useState(null)
    const [discountPercentage, setDiscountPercentage] = useState(null)

    // fetch Currency
    useEffect(() => {
        async function fetchCurrency() {
            if (!currency) {
                const ipInfoResponse = await fetch(
                    "https://ipinfo.io/json?token=01fdab52f173f3"
                )
                const ipJson = await ipInfoResponse.json()

                const ipCountry = ipJson ? ipJson.country : "US"
                // Manual set
                //const ipCountry = "GB"

                const country = getCountryByAbbreviation(ipCountry == 'GB' ? 'UK' : ipCountry)
                const { currency } = getCountry(country)

                return currency
            } else {
                return currency
            }
        }

        // Match Location Currency with Product Currencies availables
        async function matchedOption(product) {

            if (product.variants) {
                var options = product.variants[0]
            } else {
                // product is a lineItem in Cart
                var options = product.variant
            }

            const currency = await fetchCurrency()

            //Product Price
            const getPriceFromLocation = options.presentmentPrices.find(el => {
                return el.price.currencyCode === currency
            })

            const price = getPriceFromLocation
                ? getPriceFromLocation
                : options.presentmentPrices[3]

            setLocationPrice(formatLocaleCurrency(
                price.price.amount,
                price.price.currencyCode
            ))

            // Product Comparison Price
            const getComparePriceFromLocation = options.presentmentPrices.find(el => {
                return el.compareAtPrice?.currencyCode === currency
                // console.log('el.compareAtPrice')
                // console.log(el.compareAtPrice)
            })

            const ComparePrice = getComparePriceFromLocation
                ? getComparePriceFromLocation
                : options.presentmentPrices[3]

            // check if product has a comparison price in Shopify
            if (ComparePrice.compareAtPrice) {
                setLocationComparePrice(formatLocaleCurrency(
                    ComparePrice.compareAtPrice.amount,
                    ComparePrice.compareAtPrice.currencyCode
                ))

                // Calculate percentage % discount
                setDiscountPercentage(
                    //(parseFloat(price.price.amount) * 100) / parseFloat(ComparePrice.compareAtPrice.amount) - 100
                    Math.round((parseFloat(price.price.amount) * 100) / parseFloat(ComparePrice.compareAtPrice.amount) - 100)
                )
            }
        }
        matchedOption(product)
    }, [])

    return (
        <>
            {!locationPrice && (
                <img style={{ width: '25px', verticalAlign: 'middle' }} src={loading} />
            )}
            {locationPrice}
            {locationComparePrice ? <s style={{ 'opacity': '0.5', 'marginLeft': '4px', 'fontWeight': '500', 'fontSize': '16px' }}>{locationComparePrice}</s> : ''}
            {discountPercentage ? <span className={styles.discount + ' bg_primary'}>{discountPercentage}%</span> : ''}
        </>
    )

} export default LocationPrice